import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipesModule } from '../../common/pipes/pipes.module';
import { PdfIconComponent } from './pdf-icon.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [PdfIconComponent],
  imports: [CommonModule, PipesModule, MatTooltipModule, SvgIconModule],
  exports: [PdfIconComponent],
})
export class PdfIconModule {}
